import React from 'react'
import Footer from 'src/components/Footer';
import Navbar from 'src/components/Navbar';

function TrackShipment() {
    return (
        <>
            <Navbar />
            <div className='track-shipment-div custom-main-section'>
                <div className='inner-box d-flex flex-column align-items-center'>
                    <h2>Track Shipment</h2>
                    <div className='w-100'>
                        <input type="name" className="form-control form-control-lg mt-2" aria-describedby="emailHelp" placeholder='Shipment Id' />
                    </div>
                    <a href="">track</a>
                </div>
            </div>
            <Footer />
        </>
    )
}

export default TrackShipment;